module.exports = __webpack_public_path__ + "default-image.jpg?3f42261e75b305d4565cb78e35b4a22a";